// File: cgp-idle-dialog.module.ts
// Author: Joseph M Diaz
// Date: 6/8/2017
// Desc: CGP Idle / Token Refresh timers and idle dialog.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { CgpIdleService } from './cgp-idle.service';
import { CgpIdleDialogComponent } from './cgp-idle-dialog/cgp-idle-dialog.component';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    exports: [
        CgpIdleDialogComponent
    ],
    declarations: [
        CgpIdleDialogComponent
    ],
    providers: [
        CgpIdleService
    ]
})
export class CgpIdleModule { }